import { render, staticRenderFns } from "./builds.vue?vue&type=template&id=81c80f8a&scoped=true"
import script from "./builds.vue?vue&type=script&lang=js"
export * from "./builds.vue?vue&type=script&lang=js"
import style0 from "./builds.vue?vue&type=style&index=0&id=81c80f8a&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81c80f8a",
  null
  
)

export default component.exports